import { FeaturePermissions, useUserInfo } from "@next-platform/client-common-core";
import React, { lazy, Suspense } from "react";

import ChatDebugErrorBoundary from "./ChatDebugErrorBoundary";

type ChatDebugWidgetProps = {
  /** The open conversation, so a turn captured in another chat is not shown as this one's. */
  conversationId?: string | undefined;
  "data-testid"?: string;
};

/** Split into its own chunk: only `debug_chat` users download the widget code. */
const ChatDebugWidgetContent = lazy(() => import("./ChatDebugWidgetContent"));

/**
 * `debug_chat`-only turn inspector: a draggable pill with live status that opens into a floating, resizable (or
 * right-docked) panel explaining the last generated turn: rulebook, prompt, moderation, lore & memory, inference.
 */
const ChatDebugWidget = ({ conversationId, "data-testid": testId = "ChatDebugWidget" }: ChatDebugWidgetProps) => {
  const { checkIfPermissionExists } = useUserInfo();
  if (!checkIfPermissionExists(FeaturePermissions.DEBUG_CHAT)) {
    return null;
  }
  return (
    <div data-testid={testId}>
      <ChatDebugErrorBoundary>
        <Suspense fallback={null}>
          <ChatDebugWidgetContent conversationId={conversationId} />
        </Suspense>
      </ChatDebugErrorBoundary>
    </div>
  );
};

export default React.memo(ChatDebugWidget);
